import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import KIM from "./components/SearchKIM.vue";
import "../node_modules/bootstrap3/dist/js/bootstrap.min.js";
import * as uiv from "uiv";
require("./assets/css/reset.css");
require("./assets/fonts.css");
require("./assets/css/main.css");

Vue.use(uiv);
Vue.config.productionTip = false;
Vue.component("KIM", KIM);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
